<script>
import moment from "moment";
import { defineComponent, reactive } from "vue";
import { useI18n } from "vue-i18n";

// function validatorTime(rule, value, callback) {
//   if (!value) {
//     return callback();
//   }
//   if (value.time && !value.key) {
//     return callback(new Error(this.$t("message.selectTimeType")));
//   }

//   if (!value.time && value.key) {
//     return callback(new Error(this.$t("message.selectTime")));
//   }
//   return callback();
// }
// export { validatorTime };

export default defineComponent({
  name: "SelectDateRange",
  props: {
    shortcuts: {
      type: Object,
    },
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Object,
      default: () => ({
        key: "",
        time: "",
      }),
    },
    disabled: Boolean,
    size: String,
    shrink: Boolean,
    disabledDate: Function,
  },

  setup(props, context) {
    const state = reactive({ isShrink: true, data: "" });
    const { t } = useI18n();

    // const disabledDate = (time) => {
    //   return time.getTime() > Date.now();
    // };

    const onSelectChange = (val) => {
      context.emit("update:modelValue", {
        key: val,
        time: props.modelValue.time,
      });
    };
    const onDatePickerChange = (val) => {
      context.emit("update:modelValue", {
        key: props.modelValue.key,
        time: val,
      });
      // this.data = val;
    };

    const onShrink = () => {
      state.isShrink = !state.isShrink;
    };

    return () => (
      <div class="select-date-picker">
        {props.shrink ? (
          <div class="left shrink-content">
            <el-button
              class="control"
              icon="ArrowRight"
              style={
                state.isShrink ? "margin-right: 0px;" : "margin-right: 6px"
              }
              onClick={onShrink}
            />

            {!state.isShrink && (
              <el-select
                v-model={props.modelValue.key}
                disabled={props.disabled}
                size={props.size}
                clearable
                onChange={onSelectChange}
                placeholder={t("commonTipSelect")}
              >
                {props.options.map((item) => {
                  return (
                    <el-option
                      key={item.value}
                      value={item.value}
                      label={item.label}
                    ></el-option>
                  );
                })}
              </el-select>
            )}
          </div>
        ) : (
          <el-select
            class="select"
            v-model={props.modelValue.key}
            placeholder={t("commonTipSelect")}
            disabled={props.disabled}
            size={props.size}
            clearable
            onChange={onSelectChange}
          >
            {props.options.map((item) => {
              return (
                <el-option
                  key={item.value}
                  value={item.value}
                  label={item.label}
                ></el-option>
              );
            })}
          </el-select>
        )}

        <el-date-picker
          class="date-picker"
          modelValue={props.modelValue.time}
          disabled={props.disabled}
          size={props.size}
          type="datetimerange"
          range-separator={"-"}
          start-placeholder={t("commonTipStartTime")}
          end-placeholder={t("commonTipEndTime")}
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          default-time={[moment().startOf("day"), moment().endOf("day")]}
          shortcuts={props.shortcuts}
          disabled-date={props.disabledDate}
          {...{ "onUpdate:modelValue": onDatePickerChange }}
        />
      </div>
    );
  },
});
</script>
<style lang="scss" scoped>
.select-date-picker {
  display: flex;
  width: 100%;
  .left {
    margin-right: 5px;
  }
  .shrink-content {
    display: flex;
    .control {
      padding: 8px 2px;
    }
  }

  .select {
    width: 120px;
    max-width: 140px;
    min-width: 100px;
    flex: 0 1 auto;
    margin-right: 5px;
  }
  .input {
    flex: 1 1 auto;
  }
}
</style>
